import {Component, EventEmitter, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {DepositDepotExpressEnum} from "../../../../enums/deposit.enums";
import {AuthenticationService} from "../../../../services/apiServices/security/authentication.service";
import {User} from "../../../../model/user";

@Component({
  selector: 'app-express-deposit',
  templateUrl: './express-deposit.component.html',
  styleUrls: ['./express-deposit.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ExpressDepositComponent implements OnInit {
  static INFO_ERL = 'INFO';
  static PARAMS_STEP = 'PARAMS';
  static DATA_STEP = 'DATA';
  static TEMPLATE_STEP = 'TEMPLATE';
  static FORMATTING_STEP = 'FORMATTING';
  static REVIEW_STEP = 'REVIEW';
  @Output() public modalDisplay: EventEmitter<boolean>;
  @Output() public selectedTypeChanged: EventEmitter<string>;

  constructor(private authenticationService: AuthenticationService) {
    this.modalDisplay = new EventEmitter();
    this.selectedTypeChanged = new EventEmitter();
  }

  public currentUser: User;
  selectedDepositType: string;
  isErlAuthorized: boolean;

  ngOnInit() {
    this.selectedDepositType = '';
    this.currentUser = this.authenticationService.getCurrentUser();

    if (this.authenticationService.isAdminNumen()) {
      this.isErlAuthorized = true;
    } else {
      this.isErlAuthorized = this.currentUser.isErlAuthorized;
    }
  }

  closeExpressDialog(event: boolean) {
    this.modalDisplay.emit(event);
  }

  notifyTypeSelection() {
    this.selectedTypeChanged.emit(this.selectedDepositType);
  }

  protected readonly DepositDepotExpressEnum = DepositDepotExpressEnum;
}
